const SectionDescription = ({ title, content, display }) => {
  return (
    <>
      {display && (
        <div className="dyTheme1 dyBorder1 p-sm-4 reportsTable">
          <h4>{title}</h4>
          {content}
        </div>
      )}
    </>
  );
};

export default SectionDescription;